// ═══════════════════════════════════════════════════════════════════════════════
// Admin portal frontend routes (API remains /api/admin/*)
// ═══════════════════════════════════════════════════════════════════════════════

export const ADMIN_PORTAL_BASE = '/hfs-admin';

export const adminPortalPath = (suffix = ''): string => {
  const normalized = suffix.startsWith('/') ? suffix : suffix ? `/${suffix}` : '';
  return `${ADMIN_PORTAL_BASE}${normalized}`;
};
